import type { AviaryIntentions } from "aviary-tokens";

import { Button } from "@aviary/components/Button/Button";
import type { ButtonProps } from "@aviary/components/Button/Button.types";

interface IconButtonProps extends ButtonProps {
  "aria-label": string;
  intention?: Exclude<AviaryIntentions, "primary" | "success" | "textSuccess">;
}

/**
 * @deprecated Use `IconButton` from `@fullscript/aviary-web` instead.
 */
const IconButton = ({ children, ...rest }: IconButtonProps) => {
  return (
    <Button isIcon {...rest}>
      {children}
    </Button>
  );
};

export type { IconButtonProps };
export { IconButton };
